module.exports = __webpack_public_path__ + "img/19_56.8fad248a.png";